import { render, staticRenderFns } from "./PCDetail.vue?vue&type=template&id=77b7adaa&scoped=true"
import script from "./PCDetail.vue?vue&type=script&lang=js"
export * from "./PCDetail.vue?vue&type=script&lang=js"
import style0 from "./PCDetail.vue?vue&type=style&index=0&id=77b7adaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b7adaa",
  null
  
)

export default component.exports